type StorageKind = "session" | "local";

const pick = (kind: StorageKind): Storage | null => {
  if (typeof window === "undefined") return null;
  try {
    return kind === "local" ? window.localStorage : window.sessionStorage;
  } catch {
    return null;
  }
};

const safeGet = (key: string, kind: StorageKind): string | null => {
  const store = pick(kind);
  if (!store) return null;
  try {
    return store.getItem(key);
  } catch {
    return null;
  }
};

/** Returns false when the value couldn't be stored (quota, disabled). */
const safeSet = (key: string, value: string, kind: StorageKind): boolean => {
  const store = pick(kind);
  if (!store) return false;
  try {
    store.setItem(key, value);
    return true;
  } catch {
    /* quota or disabled storage */
    return false;
  }
};

const safeRemove = (key: string, kind: StorageKind): void => {
  const store = pick(kind);
  if (!store) return;
  try {
    store.removeItem(key);
  } catch {
    /* noop */
  }
};

export const sessionGet = (key: string) => safeGet(key, "session");
export const sessionSet = (key: string, value: string) =>
  safeSet(key, value, "session");
export const sessionRemove = (key: string) => safeRemove(key, "session");

export const localGet = (key: string) => safeGet(key, "local");
export const localSet = (key: string, value: string) =>
  safeSet(key, value, "local");
export const localRemove = (key: string) => safeRemove(key, "local");

export const safeJsonParse = <T>(raw: string | null, fallback: T): T => {
  if (!raw) return fallback;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
};
